<template>
  <div class="flex flex-col gap-8 overflow-hidden">
    <div class="grid grid-cols-3 gap-2 flex flex-col flex-1 overflow-hidden">
      <div
        class="flex items-center justify-between bg-light-grey py-5 px-2 rounded-xl shadow-md"
      >
        <div class="flex items-center gap-2 w-full justify-center">
          <h2 class="2xl:text-sm text-xs font-medium">
            {{ stats.idle ?? 0 }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ $t("monitor.online") }}
          </p>
        </div>
        <Button
          label="Show"
          @click="showOnlineDialog = true"
          :disabled="agents.filter((a) => a.status === 2).length === 0"
          class="bg-transparent text-primary-900 2xl:text-sm text-xs rounded-full"
          :class="
            agents.filter((a) => a.status === 2).length === 0
              ? ''
              : 'hover:!bg-primary-900 hover:!text-white cursor-pointer'
          "
        >
          <v-icon>{{
            agents.filter((a) => a.status === 2).length === 0
              ? "mdi-eye-off"
              : "mdi-eye"
          }}</v-icon>
        </Button>
      </div>
      <div
        class="flex items-center justify-between bg-light-grey py-5 px-2 rounded-xl shadow-md"
      >
        <div class="flex items-center gap-2 w-full justify-center">
          <h2 class="2xl:text-sm text-xs font-medium">
            {{ stats.rest ?? 0 }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ $t("monitor.on_break") }}
          </p>
        </div>
        <Button
          label="Show"
          @click="showBreakDialog = true"
          :disabled="agents.filter((a) => a.status === 3).length === 0"
          class="bg-transparent text-primary-900 2xl:text-sm text-xs rounded-full"
          :class="
            agents.filter((a) => a.status === 3).length === 0
              ? ''
              : 'hover:!bg-primary-900 hover:!text-white cursor-pointer'
          "
        >
          <v-icon>{{
            agents.filter((a) => a.status === 3).length === 0
              ? "mdi-eye-off"
              : "mdi-eye"
          }}</v-icon>
        </Button>
      </div>
      <div
        class="flex items-center justify-between bg-light-grey py-5 px-2 rounded-xl shadow-md"
      >
        <div class="flex items-center gap-2 w-full justify-center">
          <h2 class="2xl:text-sm text-xs font-medium">
            {{ stats.busy ?? 0 }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ $t("monitor.agents_chart.agents_not_ready") }}
          </p>
        </div>
        <Button
          label="Show"
          @click="showBusyDialog = true"
          :disabled="agents.filter((a) => a.status === 4).length === 0"
          class="bg-transparent text-primary-900 2xl:text-sm text-xs rounded-full"
          :class="
            agents.filter((a) => a.status === 4).length === 0
              ? ''
              : 'hover:!bg-primary-900 hover:!text-white cursor-pointer'
          "
        >
          <v-icon>{{
            agents.filter((a) => a.status === 4).length === 0
              ? "mdi-eye-off"
              : "mdi-eye"
          }}</v-icon>
        </Button>
      </div>
    </div>
  </div>
  <Dialog
    v-model:visible="showOnlineDialog"
    :modal="true"
    :closable="false"
    :draggable="false"
    :dismissableMask="true"
    :closeOnEscape="true"
    :closeOnBackdrop="true"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    :style="{ width: '50vw' }"
    :header="$t('monitor.online')"
  >
    <div class="flex flex-col flex-1 gap-4 overflow-y-auto grid grid-cols-2">
      <div
        v-for="agent in agents.filter((a) => a.status === 2)"
        :key="agent?.uname"
        class="flex items-center bg-light-grey p-5 rounded-xl shadow-md gap-4"
      >
        <Avatar :image="require('@/assets/user.png')" shape="circle" />
        <div class="flex flex-col">
          <h2 class="text-xs font-medium">
            {{ agent?.fullname }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ agent?.statustime ? new Date(agent.statustime).toLocaleString() : 'N/A' }}
          </p>
        </div>
      </div>
    </div>
  </Dialog>
  <Dialog
    v-model:visible="showBreakDialog"
    :modal="true"
    :closable="false"
    :draggable="false"
    :dismissableMask="true"
    :closeOnEscape="true"
    :closeOnBackdrop="true"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    :style="{ width: '50vw' }"
    :header="$t('monitor.on_break')"
  >
    <div class="flex flex-col flex-1 gap-4 overflow-y-auto grid grid-cols-2">
      <div
        v-for="agent in agents.filter((a) => a.status === 3)"
        :key="agent?.uname"
        class="flex items-center bg-light-grey p-5 rounded-xl shadow-md gap-4"
      >
        <Avatar :image="require('@/assets/user.png')" shape="circle" />
        <div class="flex flex-col">
          <h2 class="text-xs font-medium">
            {{ agent?.fullname }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ agent?.statustime ? new Date(agent.statustime).toLocaleString() : 'N/A' }}
          </p>
        </div>
      </div>
    </div>
  </Dialog>
  <Dialog
    v-model:visible="showBusyDialog"
    :modal="true"
    :closable="false"
    :draggable="false"
    :dismissableMask="true"
    :closeOnEscape="true"
    :closeOnBackdrop="true"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    :style="{ width: '50vw' }"
    :header="$t('monitor.agents_chart.agents_not_ready')"
  >
    <div class="flex flex-col flex-1 gap-4 overflow-y-auto grid grid-cols-2">
      <div
        v-for="agent in agents.filter((a) => a.status === 4)"
        :key="agent?.uname"
        class="flex items-center bg-light-grey p-5 rounded-xl shadow-md gap-4"
      >
        <Avatar :image="require('@/assets/user.png')" shape="circle" />
        <div class="flex flex-col">
          <h2 class="text-xs font-medium">
            {{ agent?.fullname }}
          </h2>
          <p class="text-xs text-gray-500">
            {{ agent?.statustime ? new Date(agent.statustime).toLocaleString() : 'N/A' }}
          </p>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { Avatar, Dialog, Button } from "primevue";

export default {
  components: {
    Avatar,
    Dialog,
    Button,
  },
  props: {
    agentsStats: {
      required: true,
    },
    agentsList: {
      required: true,
    },
  },
  data() {
    return {
      showOnlineDialog: false,
      showBreakDialog: false,
      showBusyDialog: false,
      agents: [],
      stats: {},
    };
  },

  watch: {
    agentsList(newVal) {
      this.agents = newVal;
    },
    agentsStats(newVal) {
      this.stats = newVal;
    },
  },
};
</script>
